import { useState } from 'react';
import { t } from 'ttag';
import classNames from 'classnames';

import FeedFilterTitle from '@components/FeedFilterTitle';
import Checkbox from '@ui/Checkbox';

// styles
import s from './FeedConditionFilter.sss';

// types
type ConditionOptions = {
  id: number | string;
  name: string;
};

type FeedConditionFilterProps = {
  options: ConditionOptions[];
  actives: number[];
  isMobile: boolean;
  select(id: number): void;
};

export const FeedConditionFilter: React.FC<FeedConditionFilterProps> = ({
  options,
  actives,
  select,
  isMobile,
}) => {
  const [isHide, setHide] = useState(false);
  const activeConditions = actives || [];

  return (
    (
      <div className={classNames([s.root, { [s.mobile]: isMobile }])}>
        <FeedFilterTitle
          title={t`Стан`}
          hide={isHide}
          onClick={() => setHide(!isHide)}
        />
        { !isHide && (
        <>
          {options.map((data) => (
            <Checkbox
              key={data.id}
              onCheck={() => select(+data.id)}
              checked={activeConditions.includes(+data.id)}
              className={s.input}
            >
              <span className={s.textInput}>
                {data.name}
              </span>
            </Checkbox>
          ))}
        </>
        )}
      </div>
    )
  );
};

export default FeedConditionFilter;
